import { PageHeader } from '@/modules/common/components/PageHeader';
import { CompanySettingsSearchParams } from '@/routes/_admin/settings';
import { List } from '@mui/icons-material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { getRouteApi } from '@tanstack/react-router';
import { LearningBudgetTab } from '../components/LearningBudgetTab';
import { OrganizationDetailsTab } from '../components/OrganizationDetailsTab';

const routeApi = getRouteApi('/_admin/settings/');

export function CompanySettingsPage() {
  const search = routeApi.useSearch() as CompanySettingsSearchParams;
  const navigate = routeApi.useNavigate();
  const tabValue = search.tab || 'organization';

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate({
      search: prev => ({
        ...prev,
        tab: newValue,
      }),
    });
  };

  return (
    <div className="flex flex-col h-full text-mydra-black relative">
      <PageHeader pageTitle="Organization settings" />
      <TabContext value={tabValue}>
        <TabList
          className="flex gap-5 px-8 border-b mt-8"
          onChange={handleTabChange}
          aria-label="organization settings tabs"
        >
          <Tab
            icon={<List />}
            iconPosition="start"
            label="Organization Details"
            value="organization"
          />
          <Tab
            icon={<AccountBalanceWalletOutlinedIcon />}
            iconPosition="start"
            label="Learning Budget"
            value="learning-budget"
          />
        </TabList>
        <TabPanel value="organization" className="px-8 flex-1">
          <OrganizationDetailsTab />
        </TabPanel>
        <TabPanel
          value="learning-budget"
          className="px-8 flex-1 flex flex-col h-full"
        >
          <LearningBudgetTab />
        </TabPanel>
      </TabContext>
    </div>
  );
}
